import * as React from 'react';
import Link from '@mui/material/Link';


const bookingLink = "https://www.ihg.com/kimptonhotels/hotels/us/en/find-hotels/select-roomrate?fromRedirect=true&qSrt=sBR&qIta=99801505&icdv=99801505&qSlH=BOSML&qCiD=09&qCiMy=042025&qCoD=11&qCoMy=042025&qGrpCd=HBH&qAAR=6CBARC&qRtP=6CBARC&setPMCookies=true&qSHBrC=KI&qDest=25%20Edwin%20H.%20Land%20Blvd,%20Cambridge,%20MA,%20US&srb_u=1&qChAge=&qRmFltr=DB130";

type BookingLinkProps = {
  linkText?: string,
  underline?: "hover" | "always" | "none"
};

const defaultProps: BookingLinkProps = {
  linkText: "BOOK HERE",
  underline: "hover"
};

export default function BookingLink(linkProps: BookingLinkProps = defaultProps) {
  return (
          <Link href={bookingLink} 
            sx={(theme) => ({fontWeight: "bold", color: theme.palette.grey[800]})}
            underline={linkProps.underline ? linkProps.underline : defaultProps.underline}
            >
            {linkProps.linkText ? linkProps.linkText : defaultProps.linkText}
          </Link>
  );
}